import { useEffect } from "react";

type RemovedDetail={type?:string;id?:string;heat_number?:string;drawing_number?:string};

export default function RemovedRecordUiSync(){
 useEffect(()=>{
  const onRemoved=(event:Event)=>{
   const detail=(event as CustomEvent<RemovedDetail>).detail||{};
   if(detail.type==="mtr"){
    document.querySelectorAll<HTMLElement>(".record-list article").forEach(article=>{
     const icon=article.querySelector(".record-icon")?.textContent?.trim();
     const heat=article.querySelector("div b")?.textContent?.replace(/^Heat\s+/i,"").trim();
     if(icon==="MTR"&&detail.heat_number&&heat===detail.heat_number)article.remove();
    });
    document.querySelectorAll<HTMLTableRowElement>(".mtr-table tbody tr").forEach(row=>{
     const heat=row.querySelector(".heat")?.textContent?.trim()||row.querySelector("td:first-child b")?.textContent?.trim();
     if(detail.heat_number&&heat===detail.heat_number)row.remove();
    });
   }
   if(detail.type==="drawing"){
    document.querySelectorAll<HTMLElement>(".drawing-grid article").forEach(article=>{
     if(article.querySelector("h3")?.textContent?.trim()===detail.drawing_number)article.remove();
    });
   }
  };
  window.addEventListener("arcvault:record-removed",onRemoved as EventListener);
  return()=>window.removeEventListener("arcvault:record-removed",onRemoved as EventListener);
 },[]);
 return null;
}
